/**
 * 在阅读正文中为查询词插入 <mark class="hit">，避免 innerHTML 注入
 */
export function appendHighlighted(
  parent: HTMLElement,
  text: string,
  query: string,
): void {
  parent.textContent = "";
  const q = query.trim();
  if (!q) {
    parent.appendChild(document.createTextNode(text));
    return;
  }

  let pos = 0;
  while (pos < text.length) {
    const idx = text.indexOf(q, pos);
    if (idx < 0) {
      parent.appendChild(document.createTextNode(text.slice(pos)));
      break;
    }
    if (idx > pos) {
      parent.appendChild(document.createTextNode(text.slice(pos, idx)));
    }
    const mark = document.createElement("mark");
    mark.className = "hit";
    mark.textContent = text.slice(idx, idx + q.length);
    parent.appendChild(mark);
    pos = idx + q.length;
  }
}
